// eslint-disable-next-line simple-import-sort/imports
import { format, isAfter } from 'date-fns';
import { ChangeEvent } from 'react';

import { trimClassname } from '@/utils/styleHelper';
import { uniqueIdTransfer } from '@/apiCalls/uniqueIDTransferHelper';
import { EEventType } from '../eventType';
import { Tooltip } from '../Tooltip';

export const testId = 'DateInput';
export interface IDateInput {
    title: string;
    placeholder: string;
    onChange: (value: Date) => void;
    showErrors: boolean;
    id?: string;
    disabled?: boolean;
    value?: Date;
    minDate?: Date;
    maxDate?: Date;
    dateFormat?: string;
    tooltipContent?: string;
}

export function DateInput({
    title,
    placeholder,
    id,
    value,
    showErrors,
    disabled = false,
    onChange,
    minDate,
    maxDate,
    dateFormat = 'yyyy-MM-dd',
    tooltipContent,
}: IDateInput): JSX.Element {
    const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        let date = new Date(value);

        if (maxDate && date > maxDate) {
            date = maxDate;
        }

        onChange(date);

        uniqueIdTransfer({
            eventType: EEventType.INPUT,
            applicationData: { id: id },
        });
    };

    function getDisplayValue(): string {
        if (!value) return '';
        if (maxDate && isAfter(value, maxDate))
            return format(maxDate, dateFormat);
        return format(value, dateFormat);
    }

    return (
        <div data-testid={testId} className='py-2 mx-auto w-full max-w-md'>
            <Tooltip content={tooltipContent ?? ''}>
                <h1 className='fieldHeading'>{title}</h1>
            </Tooltip>
            <input
                className={trimClassname(
                    `appearance-none border rounded-[10px] mx-auto w-full max-w-md p-2 text-textPrimary leading-tight h-8 inputButtonFocus placeholderStyle text-center ${
                        showErrors ? errorClass : ''
                    } ${
                        disabled
                            ? 'hover:none cursor-disabled'
                            : 'hover:shadow '
                    }`
                )}
                id={id}
                type='date'
                data-testid='inputField'
                placeholder={placeholder}
                value={getDisplayValue()}
                onChange={handleChange}
                disabled={disabled}
                min={minDate ? format(minDate, dateFormat) : undefined}
                max={maxDate ? format(maxDate, dateFormat) : undefined}
                pattern={dateFormat}
            />
        </div>
    );
}
export const errorClass = 'error';
